module.exports = __webpack_public_path__ + "img/8.1b0549bf.png";